<div >
    <span style="white-space: pre-line;">
        {{message}}
    </span>
    <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</div>